import { configureStore } from '@reduxjs/toolkit';
import userSlice from "./userSlice/userSlice";
import certificatesSlice from "./certificateSlice/certificateSlice";
import alertSlice from "./alertSlice/alertSlice";

const rootReducer = configureStore({
  reducer: {
    [userSlice.name]: userSlice.reducer,
    [certificatesSlice.name]: certificatesSlice.reducer,
    [alertSlice.name]: alertSlice.reducer,
  }
});

export default rootReducer;